<template>
<div id="app">

  <div v-if="!browser.isIE"> 
         
    <div id="app-header">
      <b-navbar sticky type="light" variant="canem" class="p-2">
      <b-navbar-brand href="/"> 
        <img alt="Canem" src="./assets/images/canem-logo.svg"  height="32px">
      </b-navbar-brand>
       
        <b-navbar-nav>
          <!-- <b-nav-item to="/">Home</b-nav-item> --> 
          <b-nav-item-dropdown>
            <!-- Using 'button-content' slot -->
            <template slot="button-content"><img alt="menu" src="./assets/images/menu-icon.svg"  height="24px"></template>

            <b-dropdown-group v-if="this.state.projectId">

                <b-dropdown-item v-if="state.modules.includes('journal')" v-on:click.stop="journal()"> 
                  <img style="padding-right:5px" src="@/assets/images/journal-icon.svg"  height="32px">  
                  <span id="menuitem"> Site Journal  </span>
                </b-dropdown-item>

                <b-dropdown-item v-if="state.modules.includes('poviewer')" disabled  v-on:click.stop="purchaseOrders()"> 
                  <img style="padding-right:5px" src="@/assets/images/poviewer-icon.svg"  height="32px">   
                  <span id="menuitem"> PO Viewer </span>
                </b-dropdown-item>

                <b-dropdown-item v-if="state.modules.includes('issuelog')"  v-on:click.stop="issueLog()"> 
                  <img style="padding-right:5px" src="@/assets/images/issuelog-icon.svg"  height="32px">   
                  <span id="menuitem"> Issue Log </span>
                </b-dropdown-item>                

                <b-dropdown-item v-if="state.modules.includes('photos')" v-on:click.stop="projectPhotos()"> 
                  <img style="padding-right:5px" src="@/assets/images/photos-icon.svg"  height="32px">  
                  <span id="menuitem"> Photos </span>
                </b-dropdown-item>         

                <b-dropdown-item v-if="state.modules.includes('timeentry')" v-on:click.stop="timeEntry()"> 
                  <img style="padding-right:5px" src="@/assets/images/timeentry-icon.svg"  height="32px">  
                  <span id="menuitem"> Time Entry </span>
                </b-dropdown-item>       
            
                <b-dropdown-item v-if="state.modules.includes('production')" v-on:click.stop="production()"> 
                  <img style="padding-right:5px" src="@/assets/images/production-icon.svg"  height="32px">  
                  <span id="menuitem"> Production </span>
                </b-dropdown-item>                   

            </b-dropdown-group>

            <b-dropdown-divider></b-dropdown-divider>
            
            <b-dropdown-item @click="$bvModal.show('modal-select-project')"><b id="menuitem">Select project...</b></b-dropdown-item>

            <b-dropdown-item v-for="journal in userJournals.slice(0,5)" :key="journal.id" @click="selectJournal(journal.id)">
              <b id="menuitem" v-b-tooltip.hover.v-light.right :title="journal.title">Journal {{ journal.id }}</b>
            </b-dropdown-item>
            
          </b-nav-item-dropdown> 
        
   
          <b-nav-text v-if="this.state.project">  
            <span class="width-std"> {{this.state.project}} </span> 
            <span class="width-sm"> {{this.state.projectId}} </span> 
          </b-nav-text>

        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template slot="button-content"><em> {{username}} </em></template>
            <b-dropdown-item to="/profile">Profile</b-dropdown-item>
            <b-dropdown-item v-if="isSysAdmin"  to="/sysadmin">System Admin</b-dropdown-item>
            <b-dropdown-item v-on:click.stop="logOut()">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      
    </b-navbar>

     <b-breadcrumb :items="this.state.breadcrumbs">  </b-breadcrumb> 

  </div>

   <div id="app-content">

     <!----- [--- App.vue app-content---] ----->
      <keep-alive :max="6">
          <router-view :key="$route.fullPath"> </router-view>
      </keep-alive>
     <!----- [--- App.vue app-content---] ----->

    </div>

     <!-- The modal select project -->
  <b-modal id="modal-select-project" 
          title="Select project"
          size="md"
          no-close-on-backdrop
          ok-only
          ok-title="Cancel"
  >
        
    <selectproject> </selectproject> 
  
  </b-modal>

  </div>


  <div id="unsupported" v-else>  <!-- IE browser detected -->

        <b-card header-tag="header" bg-variant="light" >
           <template v-slot:header>
            <h3 class="mb-0">  <img alt="Canem" src="./assets/images/canem-logo.svg"  height="32px"> <span class="pl-2"> WebApp </span> </h3>
          </template>
          <p>Internet Explorer is not supported by this web app.</p>
          <p>Recommended web browsers are the up to date versions of Chrome, Safari, Firefox or Microsoft Edge. </p>
          <span style="float: right;"> <b-button variant="outline-dark"  size="sm" v-on:click.stop="logOut()">Sign out</b-button> </span>

        </b-card>

  </div>

</div>

</template>

<script>
import selectproject from './components/SelectProject'

export default {
  name: 'app',
  components: {
    selectproject
  },
 
 data: function(){
    return{
      state: this.$store.state,
      data: null,
      username: null,
      userId: null,
      browser: '',
      isSysAdmin: false,
      userJournals: []
    };
  },
  
  methods:{
    logOut() {
    window.sessionStorage.clear();
    this.$auth.signOut();
    },
 
    journal() {
      this.$router.push({
        name: "Journal",
        params: { id: this.state.projectId }
      });
    },

    purchaseOrders() {
      this.$router.push({
        name: "PurchaseOrders",
        params: { id: this.state.projectId }
      });
    },    

    issueLog() {
      this.$router.push({
        name: "Issues",
        params: { id: this.state.projectId }
      });
    },    

    projectPhotos() {
      this.$router.push({
        name: "ProjectPhotos",
        params: { id: this.state.projectId }
      });
    },
    
    selectJournal(id) {
      this.$router.push({ name: 'StandaloneJournal', params: { id: id.toString() } });
    },

     setIsSysAdmin() {
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/IsSysAdmin/", {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.isSysAdmin = response.data;
            this.state.isSysAdmin = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    },    
 
      fetchUserJournals () {
      this.$auth.acquireToken().then(token => {
        this.$http
          .get("api/UserJournals", {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
            this.userJournals = response.data;
            this.state.userJournals = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      });
    }, 

   },

   created: function(){
     this.username = this.$auth.firstname();
     this.userId = this.$auth.userid();
     this.browser = this.$browserDetect;
     this.setIsSysAdmin();
     this.fetchUserJournals();
         
   },

   watch:{
    $route(to, from){
      // document.title = to.meta.title || 'Canem App';
      document.title = 'Canem' + to.path || 'Canem';
    }
  },
  
}
</script>

<style>

[v-cloak] {
  display: none;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-overflow-scrolling: touch;
  text-align: center;
  color: #2c3e50;
  max-width: 1366px;
  margin: 0 auto;
}

#app-header {
  padding: 6px;
}

#app-content {
  padding: 4px;
  text-align: center;
}

#unsupported {
  text-align: left;
  max-width: 500px;
  margin: 0 auto;
  padding-top: 40px;
}

#menuitem {
  font-size: 85%;
  font-weight:700;
  color: #494b4c;   
}

a {
  color:darkred;
}

.bg-canem {
  background-color:whitesmoke;
}

.breadcrumb {
  margin-top: 6px;
  margin-bottom: 0px;
}

.modal-title {
  color: darkred;
}
.modal-header {
  border-bottom-color: #dfb9b9;
}
.modal-footer {
  border-top-color: #dfb9b9;
}

.card{
  border-color:#dfb9b9;
}
.card-header{
  color:darkred;
}

.table .thead-light th {
  color:darkred;
}

@media (max-width: 400px) {
    .width-std {
    display: none;
  }
}
@media (min-width: 400px) {
    .width-sm {
    display: none;
  }
}

.dropdown-item.disabled img {
  filter: grayscale(100%) opacity(50%);
}

.dropdown-item.disabled #menuitem {
  color: inherit !important;
}


</style>
